export const ERROR_NO_SERVER = "no_server";
export const ERROR_CORS = "cors";
